import type { AnchorHTMLAttributes } from 'react';

export const simulateLinkClick = (opts: AnchorHTMLAttributes<HTMLAnchorElement>): void => {
  const link = document.createElement('a');
  Object.assign(link, opts);
  link.click();
};
